import { render } from "./ScrapperPage.vue?vue&type=template&id=39638976"
import script from "./ScrapperPage.vue?vue&type=script&lang=js"
export * from "./ScrapperPage.vue?vue&type=script&lang=js"

import "./ScrapperPage.vue?vue&type=style&index=0&id=39638976&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__